import axios from "axios";
import React, { Fragment, useState, useEffect, useContext } from "react";
import { Alert } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import DataTable from "../common/DataTable";
import Loader from "../common/Loader";
import APIPortalTable from "../common/Table/APIPortalTable";

const SPCDetailsModal = ({ masterCustomerID, applicationDetails }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [errorMessage, setErrorMessage] = useState("No data found for this Partner.");

  let columnsToRemoveForSPC = [
    "spc_id",
    "financial_management_system_version_detected",
    "etl_start",
    "etl_end",
    "etl_cpu_utilization",
    "etl_memory_utilization",
    "financial_error_priority",
    "financial_error_description",
  ];

  useEffect(() => {
    setLoading(true);
    const params = {
      office_id: `${masterCustomerID}`,
      limit:5000
    };
    const config ={ 
      params,
      withCredentials: false,
      headers: {
        'App-Id':`${applicationDetails.app_id}`, // ✅ Use the passed appId here
        'App-Key':`${applicationDetails.app_secret_key}`, // ✅ Use the passed appKey here
        'Content-Type': 'application/json'       
      }};      
    axios
      .get("https://api.sikkasoft.com/v4/health_check", config )
      .then((res) => {
        const items = res.data?.items || []; 
        items.forEach((data, dataIndex) => {
          data["dataIndex"] = dataIndex;
          if (data["is_inactive"] === "False") {
            data["is_inactive"] = "Active";
          } else {
            data["is_inactive"] = "Inactive";
          }
        });

        setLoading(false);
        setData(items);
        // setData(items);
      })
      .catch((error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        setLoading(false);
        setErrorMessage(error.response.data.long_message);
        // setOpenPopup(false);
        // toast.error(error.response.data.long_message + " " + error.response.data.more_information);
        // setErrors(error.response.data);
      });
  }, []);

  useEffect(() => {
    let columnsForTable = [];
    columnsForTable.push({
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "is_inactive",
      header: "Status",
    });
    if (data.length !== 0) {
      let keys = Object.keys(data[0]);
      for (let i = 0; i < keys.length; i++) {
        if (columnsToRemoveForSPC.includes(keys[i])) {
          continue;
        } else {
          if (data[0][keys[i]] !== null && typeof data[0][keys[i]] !== "object") {
            let updatedKeyName = "";
            if (keys[i] !== "is_inactive") {
              updatedKeyName = keys[i]
                .split("_")
                .map((string) => string.charAt(0).toUpperCase() + string.slice(1))
                .join(" ");
            }
            columnsForTable.push({
              csvFormatter: (cell, row, rowIndex) => {
                if (cell === "") {
                  return "--";
                } else {
                  return cell;
                }
              },
              sort: true,
              csvExport: true,
              accessorKey: keys[i],
              header: updatedKeyName,
            });
          }
        }
      }
      setColumns(columnsForTable);
    }
  }, [data]);

  const rowStyle2 = (row, rowIndex) => {
    const style = {};

    if (row.isinactive === "Inactive") {
      style.color = "#e63757";
    } else {
      style.color = "#00d27a";
    }

    return style;
  };

  return (
    <div>
      <div>
        {loading?
        <Loader/>
        :<APIPortalTable
          data={data}
          columns={columns}
          loading={loading}
          enablePagination
          CSVFileName={"SPU details data.csv"}
        />}
      </div>

      {/* {columns.length === 0 || loading ? (
        <Loader />
      ) : (
        <PaginationProvider pagination={paginationFactory(options)}>
          {({ paginationProps, paginationTableProps }) => {
            const lastIndex = paginationProps.page * paginationProps.sizePerPage;

            return (
              <Fragment>
                {loading && (
                  <div className="table-responsive" style={{ height: "350px" }}>
                    <BootstrapTable
                      bootstrap4
                      keyField="master_customer_id"
                      data={data}
                      columns={columns}
                      noDataIndication="No data to be shown!"
                      bordered={true}
                      classes="table-dashboard table-sm fs--1 border-bottom border-right border-200 mb-0 table-dashboard-th-nowrap"
                      rowClasses="btn-reveal-trigger border-top border-200"
                      rowStyle={rowStyle2}
                      headerClasses="bg-200 text-900 border-y border-200"
                      {...paginationTableProps}
                    />
                  </div>
                )}
                <Row noGutters className="px-1 py-3">
                  <Col className="pl-3 fs--1">
                    <CustomTotal {...paginationProps} lastIndex={lastIndex} />
                  </Col>
                  <Col xs="auto" className="pr-3">
                    <Button
                      color={paginationProps.page === 1 ? "light" : "primary"}
                      size="sm"
                      onClick={handlePrevPage(paginationProps)}
                      disabled={paginationProps.page === 1}
                      className="px-4"
                    >
                      Previous
                    </Button>
                    <Button
                      color={lastIndex >= paginationProps.totalSize ? "light" : "primary"}
                      size="sm"
                      onClick={handleNextPage(paginationProps)}
                      disabled={lastIndex >= paginationProps.totalSize}
                      className="px-4 ml-2"
                    >
                      Next
                    </Button>
                  </Col>
                </Row>
              </Fragment>
            );
          }}
        </PaginationProvider>
      )} */}
    </div>
  );
};

export default SPCDetailsModal;
